/**
 * Created by mgoria on 11/10/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SynchronizeCognitoDatasetException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when failed to sync a CognitoSync dataset
 */
let SynchronizeCognitoDatasetException = exports.SynchronizeCognitoDatasetException = function (_Exception) {
  _inherits(SynchronizeCognitoDatasetException, _Exception);

  /**
   * @param {String} dataset
   * @param {Object} error
   */
  function SynchronizeCognitoDatasetException(dataset, error) {
    _classCallCheck(this, SynchronizeCognitoDatasetException);

    return _possibleConstructorReturn(this, (SynchronizeCognitoDatasetException.__proto__ || Object.getPrototypeOf(SynchronizeCognitoDatasetException)).call(this, `Error on synchronizing "${dataset}" Cognito dataset. ${error}`));
  }

  return SynchronizeCognitoDatasetException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/Exception/SynchronizeCognitoDatasetException.js
// module id = 444
// module chunks = 0